<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <span class="ivu-page-header-title">{{$route.meta.title}}</span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="userForm" :model="userForm"  :label-width="75" label-position="right" @submit.native.prevent>
        <Row type="flex" :gutter="12">
          <Col>
            <FormItem label="账号搜索："  label-for="key">
              <Input search enter-button placeholder="请输入" v-model="userForm.key" @on-search="userSearchs">
<!--                <Select v-model="field_key" slot="prepend" style="width: 80px" @on-change="selectChange">-->
<!--                  <Option value="all">全部</Option>-->
<!--                  <Option value="phone">手机号</Option>-->
<!--                  <Option value="nickname">用户昵称</Option>-->
<!--                </Select>-->
              </Input>
            </FormItem>
          </Col>
        </Row>
        <Row type="flex">
          <Col>
            <Button type="primary"  icon="md-add" @click="add">添加平台用户</Button>
          </Col>
        </Row>
      </Form>
      <Table :columns="columns2" :data="userInfo" ref="table" class="ivu-mt"
             :loading="loading"
             no-userFrom-text="暂无数据"
             no-filtered-userFrom-text="暂无筛选结果"
      >
        <template slot-scope="{ row, index }" slot="status">
          <i-switch v-model="row.status" :value="row.status" :true-value="1" :false-value="0" @on-change="changeSwitch(row)">
          </i-switch>
        </template>
        <template slot-scope="{ row, index }" slot="role_name">
          <div v-for="(item,index) in row.role_name" :key="index">
            <Tag color="blue" >{{item}}</Tag>
          </div>

        </template>
        <template slot-scope="{ row, index }" slot="avatar">
          <div class="tabBox_img">
            <img :src="row.avatar ? row.avatar : require('../../assets/images/avatar.png')">
          </div>
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <a @click="edit(row.id)">编辑</a>
          <Divider type="vertical"/>
          <a @click="del(row,'删除')">删除</a>
        </template>
      </Table>
      <Page :total="dataCount" :current="userForm.page" :page-size="userForm.limit" class="acea-row row-right page" show-total  @on-change="changepage"></Page>
    </Card>
    <userEdit ref="userEdit" :id="userid" @updateStatusModel="updateStatusModel"></userEdit>
    <!--删除-->
    <modalSure ref="modalSure" title="平台用户" :id="userid" :modelApi="modelApi" @closeModal="closeModal"></modalSure>
  </div>
</template>

<script>
import { adminUserList, changeStatus, delUser } from '@/api/admin'
import userEdit from './components/userEdit'
import modalSure from '@/components/modalSure'
export default {
  name: 'adminUser',
  components: { userEdit, modalSure },
  inject: ['reload'],
  data () {
    return {
      userForm: {
        page: 1,
        limit: 10,
        key: '',
        field_key: ''
      },
      modelApi: delUser,
      dataCount: 0,
      field_key: 'all',
      userInfo: [],
      loading: false,
      userid: 0,
      columns2: [
        {
          title: '账号',
          key: 'account',
          minWidth: 120
        },
        {
          title: '头像',
          slot: 'avatar',
          minWidth: 120
        },
        {
          title: '昵称',
          key: 'nickname',
          minWidth: 120
        },
        {
          title: '角色',
          slot: 'role_name',
          minWidth: 120
        },
        {
          title: '是否启用',
          slot: 'status',
          minWidth: 120
        },
        {
          title: '最后登录时间',
          key: 'last_time',
          minWidth: 120
        },
        {
          title: '注册时间',
          key: 'ctime',
          minWidth: 120
        },
        {
          title: '操作',
          slot: 'action',
          fixed: 'right',
          minWidth: 120
        }
      ]
    }
  },
  created () {
    this.userList()
  },
  methods: {
    userList () {
      this.loading = true
      this.userForm.field_key = this.field_key === 'all' ? '' : this.field_key
      adminUserList(this.userForm).then(res => {
        let data = res.data
        this.userInfo = data.list
        this.dataCount = data.count
        this.loading = false
      }).catch(res => {
        this.loading = false
        this.$Message.error(res.msg)
      })
    },
    // 分页
    changepage (status) {
      this.userForm.page = status
      this.userList()
    },
    // 表格搜索
    userSearchs () {
      this.userForm.page = 1
      this.userList()
    },
    selectChange () {
      this.userForm.key = ''
    },
    // 启用禁用用户
    changeSwitch (row) {
      changeStatus(row.id).then(async res => {
        this.$Message.success(res.msg)
        this.userList()
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },
    edit (id) {
      this.userid = id
      this.$refs.userEdit.isShow = true
    },
    // 添加
    add () {
      this.$refs.userEdit.isShow = true
    },
    del (row) {
      this.userid = row.id
      this.$refs.modalSure.isShow = true
    },
    updateStatusModel () {
      this.reload()
    },
    closeModal (val) {
      this.userList()
    }
  }
}
</script>
